function valueOr(defaultValue, resolver) {
  try {
    const result = resolver();
    return result == null ? defaultValue : result;
  } catch (_) {
    return defaultValue;
  }
}

module.exports = {
  type: () => valueOr("browser", () => (typeof navigator !== "undefined" ? navigator.platform : "browser")),
  arch: () => valueOr("unknown", () => (typeof navigator !== "undefined" ? navigator.cpuClass || "unknown" : "unknown")),
  release: () => "",
};
